/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-pictograms
 *
 */

import React from 'react'

export * from './directory'

export const Pictograms = {
  Accessibility: React.lazy(() =>
    import('./Accessibility').then(({ Accessibility }) => ({
      default: Accessibility,
    }))
  ),
  Agent: React.lazy(() =>
    import('./Agent').then(({ Agent }) => ({
      default: Agent,
    }))
  ),
  Bank: React.lazy(() =>
    import('./Bank').then(({ Bank }) => ({
      default: Bank,
    }))
  ),
  BarChart: React.lazy(() =>
    import('./BarChart').then(({ BarChart }) => ({
      default: BarChart,
    }))
  ),
  Bell: React.lazy(() =>
    import('./Bell').then(({ Bell }) => ({
      default: Bell,
    }))
  ),
  Bills: React.lazy(() =>
    import('./Bills').then(({ Bills }) => ({
      default: Bills,
    }))
  ),
  Binoculars: React.lazy(() =>
    import('./Binoculars').then(({ Binoculars }) => ({
      default: Binoculars,
    }))
  ),
  Book: React.lazy(() =>
    import('./Book').then(({ Book }) => ({
      default: Book,
    }))
  ),
  Bullet: React.lazy(() =>
    import('./Bullet').then(({ Bullet }) => ({
      default: Bullet,
    }))
  ),
  Calendar: React.lazy(() =>
    import('./Calendar').then(({ Calendar }) => ({
      default: Calendar,
    }))
  ),
  Cash: React.lazy(() =>
    import('./Cash').then(({ Cash }) => ({
      default: Cash,
    }))
  ),
  CashAtm: React.lazy(() =>
    import('./CashAtm').then(({ CashAtm }) => ({
      default: CashAtm,
    }))
  ),
  CashCalendar: React.lazy(() =>
    import('./CashCalendar').then(({ CashCalendar }) => ({
      default: CashCalendar,
    }))
  ),
  CashContactlessPayment: React.lazy(() =>
    import('./CashContactlessPayment').then(({ CashContactlessPayment }) => ({
      default: CashContactlessPayment,
    }))
  ),
  CashDocuments: React.lazy(() =>
    import('./CashDocuments').then(({ CashDocuments }) => ({
      default: CashDocuments,
    }))
  ),
  CashFlower: React.lazy(() =>
    import('./CashFlower').then(({ CashFlower }) => ({
      default: CashFlower,
    }))
  ),
  CashFree: React.lazy(() =>
    import('./CashFree').then(({ CashFree }) => ({
      default: CashFree,
    }))
  ),
  CashMoney: React.lazy(() =>
    import('./CashMoney').then(({ CashMoney }) => ({
      default: CashMoney,
    }))
  ),
  CashPaymentCard: React.lazy(() =>
    import('./CashPaymentCard').then(({ CashPaymentCard }) => ({
      default: CashPaymentCard,
    }))
  ),
  CashSecurity: React.lazy(() =>
    import('./CashSecurity').then(({ CashSecurity }) => ({
      default: CashSecurity,
    }))
  ),
  CashStart: React.lazy(() =>
    import('./CashStart').then(({ CashStart }) => ({
      default: CashStart,
    }))
  ),
  CashThumbsUp: React.lazy(() =>
    import('./CashThumbsUp').then(({ CashThumbsUp }) => ({
      default: CashThumbsUp,
    }))
  ),
  CashUmbrella: React.lazy(() =>
    import('./CashUmbrella').then(({ CashUmbrella }) => ({
      default: CashUmbrella,
    }))
  ),
  CashWarning: React.lazy(() =>
    import('./CashWarning').then(({ CashWarning }) => ({
      default: CashWarning,
    }))
  ),
  Chart: React.lazy(() =>
    import('./Chart').then(({ Chart }) => ({
      default: Chart,
    }))
  ),
  Chat: React.lazy(() =>
    import('./Chat').then(({ Chat }) => ({
      default: Chat,
    }))
  ),
  Chatbot: React.lazy(() =>
    import('./Chatbot').then(({ Chatbot }) => ({
      default: Chatbot,
    }))
  ),
  Check: React.lazy(() =>
    import('./Check').then(({ Check }) => ({
      default: Check,
    }))
  ),
  Clipboard: React.lazy(() =>
    import('./Clipboard').then(({ Clipboard }) => ({
      default: Clipboard,
    }))
  ),
  Crypto: React.lazy(() =>
    import('./Crypto').then(({ Crypto }) => ({
      default: Crypto,
    }))
  ),
  CryptoC: React.lazy(() =>
    import('./CryptoC').then(({ CryptoC }) => ({
      default: CryptoC,
    }))
  ),
  CryptoOrderTypesBuyInShares: React.lazy(() =>
    import('./CryptoOrderTypesBuyInShares').then(
      ({ CryptoOrderTypesBuyInShares }) => ({
        default: CryptoOrderTypesBuyInShares,
      })
    )
  ),
  CryptoOrderTypesBuyLimit: React.lazy(() =>
    import('./CryptoOrderTypesBuyLimit').then(
      ({ CryptoOrderTypesBuyLimit }) => ({
        default: CryptoOrderTypesBuyLimit,
      })
    )
  ),
  CryptoOrderTypesBuyLimitStop: React.lazy(() =>
    import('./CryptoOrderTypesBuyLimitStop').then(
      ({ CryptoOrderTypesBuyLimitStop }) => ({
        default: CryptoOrderTypesBuyLimitStop,
      })
    )
  ),
  CryptoOrderTypesBuyMarket: React.lazy(() =>
    import('./CryptoOrderTypesBuyMarket').then(
      ({ CryptoOrderTypesBuyMarket }) => ({
        default: CryptoOrderTypesBuyMarket,
      })
    )
  ),
  CryptoOrderTypesBuyStop: React.lazy(() =>
    import('./CryptoOrderTypesBuyStop').then(({ CryptoOrderTypesBuyStop }) => ({
      default: CryptoOrderTypesBuyStop,
    }))
  ),
  CryptoOrderTypesBuyTrailingStop: React.lazy(() =>
    import('./CryptoOrderTypesBuyTrailingStop').then(
      ({ CryptoOrderTypesBuyTrailingStop }) => ({
        default: CryptoOrderTypesBuyTrailingStop,
      })
    )
  ),
  CryptoOrderTypesBuyWithCrypto: React.lazy(() =>
    import('./CryptoOrderTypesBuyWithCrypto').then(
      ({ CryptoOrderTypesBuyWithCrypto }) => ({
        default: CryptoOrderTypesBuyWithCrypto,
      })
    )
  ),
  CryptoOrderTypesBuyWithDollars: React.lazy(() =>
    import('./CryptoOrderTypesBuyWithDollars').then(
      ({ CryptoOrderTypesBuyWithDollars }) => ({
        default: CryptoOrderTypesBuyWithDollars,
      })
    )
  ),
  CryptoOrderTypesRecurringInvestment: React.lazy(() =>
    import('./CryptoOrderTypesRecurringInvestment').then(
      ({ CryptoOrderTypesRecurringInvestment }) => ({
        default: CryptoOrderTypesRecurringInvestment,
      })
    )
  ),
  CryptoOrderTypesSellLimit: React.lazy(() =>
    import('./CryptoOrderTypesSellLimit').then(
      ({ CryptoOrderTypesSellLimit }) => ({
        default: CryptoOrderTypesSellLimit,
      })
    )
  ),
  CryptoOrderTypesSellLimitStop: React.lazy(() =>
    import('./CryptoOrderTypesSellLimitStop').then(
      ({ CryptoOrderTypesSellLimitStop }) => ({
        default: CryptoOrderTypesSellLimitStop,
      })
    )
  ),
  CryptoOrderTypesSellMarket: React.lazy(() =>
    import('./CryptoOrderTypesSellMarket').then(
      ({ CryptoOrderTypesSellMarket }) => ({
        default: CryptoOrderTypesSellMarket,
      })
    )
  ),
  CryptoOrderTypesSellStop: React.lazy(() =>
    import('./CryptoOrderTypesSellStop').then(
      ({ CryptoOrderTypesSellStop }) => ({
        default: CryptoOrderTypesSellStop,
      })
    )
  ),
  CryptoOrderTypesSellTrailingStop: React.lazy(() =>
    import('./CryptoOrderTypesSellTrailingStop').then(
      ({ CryptoOrderTypesSellTrailingStop }) => ({
        default: CryptoOrderTypesSellTrailingStop,
      })
    )
  ),
  Deposit: React.lazy(() =>
    import('./Deposit').then(({ Deposit }) => ({
      default: Deposit,
    }))
  ),
  Desktop: React.lazy(() =>
    import('./Desktop').then(({ Desktop }) => ({
      default: Desktop,
    }))
  ),
  Documents: React.lazy(() =>
    import('./Documents').then(({ Documents }) => ({
      default: Documents,
    }))
  ),
  DollarSign: React.lazy(() =>
    import('./DollarSign').then(({ DollarSign }) => ({
      default: DollarSign,
    }))
  ),
  Envelope: React.lazy(() =>
    import('./Envelope').then(({ Envelope }) => ({
      default: Envelope,
    }))
  ),
  Etf: React.lazy(() =>
    import('./Etf').then(({ Etf }) => ({
      default: Etf,
    }))
  ),
  EyeOpen: React.lazy(() =>
    import('./EyeOpen').then(({ EyeOpen }) => ({
      default: EyeOpen,
    }))
  ),
  Face: React.lazy(() =>
    import('./Face').then(({ Face }) => ({
      default: Face,
    }))
  ),
  Flag: React.lazy(() =>
    import('./Flag').then(({ Flag }) => ({
      default: Flag,
    }))
  ),
  Flower: React.lazy(() =>
    import('./Flower').then(({ Flower }) => ({
      default: Flower,
    }))
  ),
  Free: React.lazy(() =>
    import('./Free').then(({ Free }) => ({
      default: Free,
    }))
  ),
  Gift: React.lazy(() =>
    import('./Gift').then(({ Gift }) => ({
      default: Gift,
    }))
  ),
  GoldBarChart: React.lazy(() =>
    import('./GoldBarChart').then(({ GoldBarChart }) => ({
      default: GoldBarChart,
    }))
  ),
  GoldCalendar: React.lazy(() =>
    import('./GoldCalendar').then(({ GoldCalendar }) => ({
      default: GoldCalendar,
    }))
  ),
  GoldDocuments: React.lazy(() =>
    import('./GoldDocuments').then(({ GoldDocuments }) => ({
      default: GoldDocuments,
    }))
  ),
  GoldGift: React.lazy(() =>
    import('./GoldGift').then(({ GoldGift }) => ({
      default: GoldGift,
    }))
  ),
  GoldMargin: React.lazy(() =>
    import('./GoldMargin').then(({ GoldMargin }) => ({
      default: GoldMargin,
    }))
  ),
  GoldMoney: React.lazy(() =>
    import('./GoldMoney').then(({ GoldMoney }) => ({
      default: GoldMoney,
    }))
  ),
  GoldPiggyBank: React.lazy(() =>
    import('./GoldPiggyBank').then(({ GoldPiggyBank }) => ({
      default: GoldPiggyBank,
    }))
  ),
  GoldStopwatch: React.lazy(() =>
    import('./GoldStopwatch').then(({ GoldStopwatch }) => ({
      default: GoldStopwatch,
    }))
  ),
  Help: React.lazy(() =>
    import('./Help').then(({ Help }) => ({
      default: Help,
    }))
  ),
  Investing: React.lazy(() =>
    import('./Investing').then(({ Investing }) => ({
      default: Investing,
    }))
  ),
  Lightbulb: React.lazy(() =>
    import('./Lightbulb').then(({ Lightbulb }) => ({
      default: Lightbulb,
    }))
  ),
  Lightning: React.lazy(() =>
    import('./Lightning').then(({ Lightning }) => ({
      default: Lightning,
    }))
  ),
  List: React.lazy(() =>
    import('./List').then(({ List }) => ({
      default: List,
    }))
  ),
  LiveChat: React.lazy(() =>
    import('./LiveChat').then(({ LiveChat }) => ({
      default: LiveChat,
    }))
  ),
  Lock: React.lazy(() =>
    import('./Lock').then(({ Lock }) => ({
      default: Lock,
    }))
  ),
  Margin: React.lazy(() =>
    import('./Margin').then(({ Margin }) => ({
      default: Margin,
    }))
  ),
  Megaphone: React.lazy(() =>
    import('./Megaphone').then(({ Megaphone }) => ({
      default: Megaphone,
    }))
  ),
  Money: React.lazy(() =>
    import('./Money').then(({ Money }) => ({
      default: Money,
    }))
  ),
  OrderTypesBuyInShares: React.lazy(() =>
    import('./OrderTypesBuyInShares').then(({ OrderTypesBuyInShares }) => ({
      default: OrderTypesBuyInShares,
    }))
  ),
  OrderTypesBuyLimit: React.lazy(() =>
    import('./OrderTypesBuyLimit').then(({ OrderTypesBuyLimit }) => ({
      default: OrderTypesBuyLimit,
    }))
  ),
  OrderTypesBuyLimitStop: React.lazy(() =>
    import('./OrderTypesBuyLimitStop').then(({ OrderTypesBuyLimitStop }) => ({
      default: OrderTypesBuyLimitStop,
    }))
  ),
  OrderTypesBuyMarket: React.lazy(() =>
    import('./OrderTypesBuyMarket').then(({ OrderTypesBuyMarket }) => ({
      default: OrderTypesBuyMarket,
    }))
  ),
  OrderTypesBuyStop: React.lazy(() =>
    import('./OrderTypesBuyStop').then(({ OrderTypesBuyStop }) => ({
      default: OrderTypesBuyStop,
    }))
  ),
  OrderTypesBuyTrailingStop: React.lazy(() =>
    import('./OrderTypesBuyTrailingStop').then(
      ({ OrderTypesBuyTrailingStop }) => ({
        default: OrderTypesBuyTrailingStop,
      })
    )
  ),
  OrderTypesBuyWithDollars: React.lazy(() =>
    import('./OrderTypesBuyWithDollars').then(
      ({ OrderTypesBuyWithDollars }) => ({
        default: OrderTypesBuyWithDollars,
      })
    )
  ),
  OrderTypesRecurringInvestment: React.lazy(() =>
    import('./OrderTypesRecurringInvestment').then(
      ({ OrderTypesRecurringInvestment }) => ({
        default: OrderTypesRecurringInvestment,
      })
    )
  ),
  OrderTypesSellLimit: React.lazy(() =>
    import('./OrderTypesSellLimit').then(({ OrderTypesSellLimit }) => ({
      default: OrderTypesSellLimit,
    }))
  ),
  OrderTypesSellLimitStop: React.lazy(() =>
    import('./OrderTypesSellLimitStop').then(({ OrderTypesSellLimitStop }) => ({
      default: OrderTypesSellLimitStop,
    }))
  ),
  OrderTypesSellMarket: React.lazy(() =>
    import('./OrderTypesSellMarket').then(({ OrderTypesSellMarket }) => ({
      default: OrderTypesSellMarket,
    }))
  ),
  OrderTypesSellStop: React.lazy(() =>
    import('./OrderTypesSellStop').then(({ OrderTypesSellStop }) => ({
      default: OrderTypesSellStop,
    }))
  ),
  OrderTypesSellTrailingStop: React.lazy(() =>
    import('./OrderTypesSellTrailingStop').then(
      ({ OrderTypesSellTrailingStop }) => ({
        default: OrderTypesSellTrailingStop,
      })
    )
  ),
  PaymentCard: React.lazy(() =>
    import('./PaymentCard').then(({ PaymentCard }) => ({
      default: PaymentCard,
    }))
  ),
  Payroll: React.lazy(() =>
    import('./Payroll').then(({ Payroll }) => ({
      default: Payroll,
    }))
  ),
  PercentSign: React.lazy(() =>
    import('./PercentSign').then(({ PercentSign }) => ({
      default: PercentSign,
    }))
  ),
  Person: React.lazy(() =>
    import('./Person').then(({ Person }) => ({
      default: Person,
    }))
  ),
  Phone: React.lazy(() =>
    import('./Phone').then(({ Phone }) => ({
      default: Phone,
    }))
  ),
  PieChart: React.lazy(() =>
    import('./PieChart').then(({ PieChart }) => ({
      default: PieChart,
    }))
  ),
  PiggyBank: React.lazy(() =>
    import('./PiggyBank').then(({ PiggyBank }) => ({
      default: PiggyBank,
    }))
  ),
  PoundSign: React.lazy(() =>
    import('./PoundSign').then(({ PoundSign }) => ({
      default: PoundSign,
    }))
  ),
  PrimeChart: React.lazy(() =>
    import('./PrimeChart').then(({ PrimeChart }) => ({
      default: PrimeChart,
    }))
  ),
  PrimeDollarSign: React.lazy(() =>
    import('./PrimeDollarSign').then(({ PrimeDollarSign }) => ({
      default: PrimeDollarSign,
    }))
  ),
  PrimeFlag: React.lazy(() =>
    import('./PrimeFlag').then(({ PrimeFlag }) => ({
      default: PrimeFlag,
    }))
  ),
  PrimeFlower: React.lazy(() =>
    import('./PrimeFlower').then(({ PrimeFlower }) => ({
      default: PrimeFlower,
    }))
  ),
  PrimeForwardSplit: React.lazy(() =>
    import('./PrimeForwardSplit').then(({ PrimeForwardSplit }) => ({
      default: PrimeForwardSplit,
    }))
  ),
  PrimeGift: React.lazy(() =>
    import('./PrimeGift').then(({ PrimeGift }) => ({
      default: PrimeGift,
    }))
  ),
  PrimeMoney: React.lazy(() =>
    import('./PrimeMoney').then(({ PrimeMoney }) => ({
      default: PrimeMoney,
    }))
  ),
  PrimePieChart: React.lazy(() =>
    import('./PrimePieChart').then(({ PrimePieChart }) => ({
      default: PrimePieChart,
    }))
  ),
  PrimePoundSign: React.lazy(() =>
    import('./PrimePoundSign').then(({ PrimePoundSign }) => ({
      default: PrimePoundSign,
    }))
  ),
  PrimeRecurring: React.lazy(() =>
    import('./PrimeRecurring').then(({ PrimeRecurring }) => ({
      default: PrimeRecurring,
    }))
  ),
  PrimeRetirement: React.lazy(() =>
    import('./PrimeRetirement').then(({ PrimeRetirement }) => ({
      default: PrimeRetirement,
    }))
  ),
  PrimeReverseSplit: React.lazy(() =>
    import('./PrimeReverseSplit').then(({ PrimeReverseSplit }) => ({
      default: PrimeReverseSplit,
    }))
  ),
  PrimeRobot: React.lazy(() =>
    import('./PrimeRobot').then(({ PrimeRobot }) => ({
      default: PrimeRobot,
    }))
  ),
  Recurring: React.lazy(() =>
    import('./Recurring').then(({ Recurring }) => ({
      default: Recurring,
    }))
  ),
  Retirement: React.lazy(() =>
    import('./Retirement').then(({ Retirement }) => ({
      default: Retirement,
    }))
  ),
  Robinhood: React.lazy(() =>
    import('./Robinhood').then(({ Robinhood }) => ({
      default: Robinhood,
    }))
  ),
  Smiley: React.lazy(() =>
    import('./Smiley').then(({ Smiley }) => ({
      default: Smiley,
    }))
  ),
  Sparkle: React.lazy(() =>
    import('./Sparkle').then(({ Sparkle }) => ({
      default: Sparkle,
    }))
  ),
  Start: React.lazy(() =>
    import('./Start').then(({ Start }) => ({
      default: Start,
    }))
  ),
  Stopwatch: React.lazy(() =>
    import('./Stopwatch').then(({ Stopwatch }) => ({
      default: Stopwatch,
    }))
  ),
  Submarine: React.lazy(() =>
    import('./Submarine').then(({ Submarine }) => ({
      default: Submarine,
    }))
  ),
  Transfer: React.lazy(() =>
    import('./Transfer').then(({ Transfer }) => ({
      default: Transfer,
    }))
  ),
  Umbrella: React.lazy(() =>
    import('./Umbrella').then(({ Umbrella }) => ({
      default: Umbrella,
    }))
  ),
  Unlock: React.lazy(() =>
    import('./Unlock').then(({ Unlock }) => ({
      default: Unlock,
    }))
  ),
  Warning: React.lazy(() =>
    import('./Warning').then(({ Warning }) => ({
      default: Warning,
    }))
  ),
  Withdraw: React.lazy(() =>
    import('./Withdraw').then(({ Withdraw }) => ({
      default: Withdraw,
    }))
  ),
}
